(function($) {
'use strict'

	const $body = document.body

	/* Add classes to body when main nav is opened/closed */
	const $mainNavbarCollapsible = document.getElementById('main-navbar-dropdown')
	const mainMenuOpenClass = 'main-menu-open'

	$mainNavbarCollapsible.addEventListener('show.bs.collapse', function () {
			$body.classList.add(mainMenuOpenClass)
		})
	$mainNavbarCollapsible.addEventListener('hidden.bs.collapse', function () {
			$body.classList.remove(mainMenuOpenClass)
		})

	// Add livechat div to item-livechat items
	const $livechatItemsMobile = document.querySelectorAll('.item-livechat-mobile')
	const $livechatItemsDesktop = document.querySelectorAll('.item-livechat')

	$livechatItemsMobile.forEach(function(element, key, parent) {
		const $livechatDiv = document.createElement('div')
		$livechatDiv.id = 'Betcris-mx-NewSite-Frontend-ES'

		const $livechatItemLink = element.getElementsByTagName('a')[0]

		$livechatItemLink.appendChild($livechatDiv)
	})

	$livechatItemsDesktop.forEach(function(element, key, parent) {
		const $livechatDiv = document.createElement('div')
		$livechatDiv.id = 'Betcris-mx-NewSite-Frontend-ES-Desktop'

		const $livechatItemLink = element.getElementsByTagName('a')[0]

		$livechatItemLink.appendChild($livechatDiv)
	})

	// Hide categories articles after n items
	const $categoriesItems = $('.categories-list--articles, .categories-list--section').find('> .category-item')

	if ($categoriesItems) {
		if ($categoriesItems.length > 0) {
			$categoriesItems.each(function(index, elem) {
				const maxItems = 6
				const maxItemsPosition = maxItems - 1

				const $categoryArticles = $(elem).find('> .posts-list > .list-item')
				const $categoryReadmore = $(elem).find('> .more-articles-wrapper')

				const statusDataAttr = 'toggleStatus'
				const closedStatus = 'closed'
				const openStatus = 'open'
				const seeMoreTxt = 'Ver más'
				const seeLessTxt = 'Ver menos'

				$categoryArticles.eq(maxItemsPosition).nextAll().slideUp()

				$categoryReadmore.find('a').data(statusDataAttr, closedStatus).on('click', function(event) {
					event.preventDefault()

					$categoryArticles.eq(maxItemsPosition).nextAll().slideToggle()

					if ( $(this).data(statusDataAttr) == closedStatus ) {
						$(this).data(statusDataAttr, openStatus )
						$(this).text(seeLessTxt)
					}
					else {
						$(this).data(statusDataAttr, closedStatus )
						$(this).text(seeMoreTxt)
					}
				})

				if ($categoryArticles.length <= maxItems) {
					$categoryReadmore.addClass('d-none')
				}
			})
		}
	}
})(jQuery)

